import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { CommonInterfaceSubscription } from 'subscription/view-models/common-interface-subscription';
// import { transformParenthood } from 'shell/utils/consult-person/response-transformer/registry-office/parenthood';
import { transformPerson } from 'shell/utils/consult-person/response-transformer/person/person';
import { transformGenerality } from 'shell/utils/consult-person/response-transformer/registry-office/generality';
import { AnprVM } from 'shell/view-models/search-anpr';

export const transformerParenthoodData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>,
  isCohabitation?: boolean
): AnprVM<CommonInterfaceSubscription> => {
  // const parenthood = transformParenthood(person) || [];

  return {
    warnings: (response.data.payload?.risposta3002OK?.listaAnomalie?.errore || []).map(
      (warning) => ({
        id: warning.codiceErroreAnomalia,
        value: warning.testoErroreAnomalia,
      })
    ),
    errors: (response.data.payload?.rispostaKO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
    persons: (response.data.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || []).map(
      (person) => {
        const personVM = transformPerson(person);
        const generality = transformGenerality(person);
        const residenceArray = person.residenza || [];

        let birthplace = '';
        // birthplace check for object
        if (person.generalita?.luogoNascita?.localita) {
          birthplace = `${person.generalita?.luogoNascita?.localita.descrizioneLocalita} (${person.generalita?.luogoNascita?.localita.descrizioneStato})`;
        }

        if (person.generalita?.luogoNascita?.comune) {
          birthplace = `${person.generalita?.luogoNascita?.comune.nomeComune} (${person.generalita?.luogoNascita?.comune.siglaProvinciaIstat})`;
        }
        // Residence check for object
        let residence = '';
        // scelgo il primo o è un array?
        if (residenceArray[0]?.indirizzo) {
          residence = `${residenceArray[0]?.indirizzo.comune?.nomeComune || ''} (${
            residenceArray[0]?.indirizzo.comune?.siglaProvinciaIstat || ''
          })`;
        }
        // scelgo il primo o è un array?
        if (residenceArray[0]?.localitaEstera) {
          residence = `${residenceArray[0]?.localitaEstera.indirizzoEstero?.localita?.descrizioneLocalita} (${residenceArray[0]?.localitaEstera.indirizzoEstero?.localita?.descrizioneStato})`;
        }

        let state = '';
        // state check for object
        if (residenceArray[0]?.indirizzo?.toponimo) {
          const toponym = residenceArray[0]?.indirizzo?.toponimo;

          const civic = residenceArray[0]?.indirizzo?.numeroCivico;

          state = `${toponym.specie || ''} ${toponym?.denominazioneToponimo || ''},${
            civic?.numero || ''
          }${civic?.esponente1 ? `/${civic.esponente1}${civic.lettera || ''}` : ''}`;
        }

        if (person.generalita?.soggettoAIRE && person.generalita?.soggettoAIRE === 'S') {
          state = 'Iscritto AIRE';
        }

        if (person.datiCancellazione && person.datiCancellazione?.descrizioneMotivoCancellazione) {
          state = `${person.datiCancellazione.descrizioneMotivoCancellazione}`;
        }
        return {
          fatherhood: {
            generality: generality
              ? {
                  ...generality,
                  aire: isCohabitation ? 'N' : !generality.aire ? 'N' : generality.aire,
                }
              : undefined,
            person: {
              ...personVM,
              gender: generality?.gender,
              fiscalCodeSearchPerson: personVM?.fiscalCode,
              surnameSearchPerson: personVM?.surname,
              nameSearchPerson: personVM?.name,
              withoutNameSearchPerson: personVM?.withoutName,
              withoutSurnameSearchPerson: personVM?.withoutSurname,
            },
            birthPlace: birthplace,
            residenceString: residence,
            state,
            dati3002: person,
          },
          motherhood: {
            dati3002: person,
            generality: generality
              ? {
                  ...generality,
                  aire: isCohabitation ? 'N' : !generality.aire ? 'N' : generality.aire,
                }
              : undefined,
            person: {
              ...personVM,
              gender: generality?.gender,
              fiscalCodeSearchPerson: personVM?.fiscalCode,
              surnameSearchPerson: personVM?.surname,
              nameSearchPerson: personVM?.name,
              withoutNameSearchPerson: personVM?.withoutName,
              withoutSurnameSearchPerson: personVM?.withoutSurname,
            },
            birthPlace: birthplace,
            residenceString: residence,
            state,
          },
        };
      }
    ),
  };
};
